import { deleteCookie, getCookie, getCookies, setCookie } from 'cookies-next';
import { TmpCookiesObj } from 'cookies-next/lib/types';

export type SsrStorage = Pick<
  globalThis.Storage,
  'getItem' | 'setItem' | 'removeItem'
> & {
  keys: () => string[];
};

const getSsrCookieStorage = (cookies?: TmpCookiesObj): SsrStorage => ({
  getItem: (key: string) => {
    try {
      const cookieValue = cookies?.[`ssr-${key}`] || getCookie(`ssr-${key}`);

      return cookieValue ? `${cookieValue}` : '';
    } catch {
      return null;
    }
  },
  setItem: (key: string, value: string) => {
    try {
      setCookie(`ssr-${key}`, value);
    } catch {
      /* empty */
    }
  },
  removeItem: (key: string) => {
    try {
      deleteCookie(`ssr-${key}`);
    } catch {
      /* empty */
    }
  },
  keys: () => {
    try {
      const cookies = getCookies();
      return Object.keys(cookies)
        .filter(key => key.startsWith('ssr-'))
        .map(key => key.replace(/^ssr-/, ''));
    } catch {
      return [];
    }
  },
});

export default getSsrCookieStorage;
